import {IPresenter} from "@/rawdogjs/src/interfaces/IPresenter";
import {ErrorBase} from "@/rawdogjs/src/core/ErrorBase";
import {CaptureEmailView} from "./captureEmailView";
import {TenantApi} from "../../../services/api/base/TenantApi";
import {UserStore} from "../../../data/stores/UserStore";
import {Router} from "@/rawdogjs/src/router";
import {HandleApi} from "../../../services/api/base/HandleApi";
import {LoadingPresenter} from "../../loading/loadingPresenter";
import {TenantProfileStore} from "../../../data/stores/TenantProfileStore";
import {TenantProfileApi} from "../../../services/api/base/TenantProfileApi";
import {ParcelDependencyContainer} from "@/rawdogjs/src/core/ParcelDependencyContainer";
import {RenderComponent} from "@/rawdogjs/src/renderRoute";
import {ValidationError} from "@/rawdogjs/src/core/ValidationError";
import {UuidHelper} from "../../../shared/IdentityHelper";
import {BookingApi} from "../../../services/api/base/BookingApi";
import {BookingStore} from "@/data/stores/BookingStore";

export class CaptureEmailPresenter implements IPresenter {

    public errors: ErrorBase[] = [];
    public serverErrors: ErrorBase[] = [];

    private PASSWORD_MAX_LENGTH = 8;

    public readonly _view: CaptureEmailView;

    private readonly _tenantApi: TenantApi;
    private readonly _userStore: UserStore;
    private readonly _router: Router;
    private _handleApi: HandleApi;
    private _loading: LoadingPresenter;
    private _tenantProfileStore: TenantProfileStore;
    private _tenantProfileApi: TenantProfileApi;
    private dependencyContainer: ParcelDependencyContainer;
    private _queryParams: Record<string, string>;
    private _bedrooms: number;
    private _bathrooms: number;

    constructor(view: CaptureEmailView, router: Router, dependencyInjection: ParcelDependencyContainer) {

        this._view = view;
        this._router = router;
        this.dependencyContainer = dependencyInjection;

        this._tenantApi = dependencyInjection.resolve<TenantApi>('TenantApi');
        this._handleApi = dependencyInjection.resolve<HandleApi>('HandleApi');
        this._userStore = dependencyInjection.resolve<UserStore>('UserStore');
        this._tenantProfileStore = dependencyInjection.resolve<TenantProfileStore>('TenantProfileStore');
        this._tenantProfileApi = dependencyInjection.resolve<TenantProfileApi>('TenantProfileApi');


    }

    async handleFormChange(fieldSelector: string, value: string, fieldName: string) {
        // validate and then set the field errors
        await this.validate();
        this._view.setFieldErrors(this.getCombinedErrors(), fieldName);
    }

    async initialize() {

        this._queryParams = this._router.getQueryParams();

        if (this._queryParams) {
            const bedroomsParam = this._queryParams['bedrooms'];
            const bathroomsParam = this._queryParams['bathrooms'];
            if (bedroomsParam) this._bedrooms = parseFloat(bedroomsParam);
            if (bathroomsParam) this._bathrooms = parseFloat(bathroomsParam);
        }

        const renderComponent = new RenderComponent(this._router);
        this._loading = await renderComponent.render<LoadingPresenter>('loading');
        this._view.$element.append(this._loading._view.$element);

        this._view.bind(
            this,
            async (fieldSelector, value, fieldName) => {
                await this.handleFormChange(fieldSelector, value, fieldName);
            }
        );


        // this._view.addOnClickHandler('#btn-sign-up', async () => {
        //     console.log('sign up');
        //     await this.signUp();
        //    
        // })
        // //
        // this._view.addFieldEventHandler('email', ['input', 'blur'],
        //     async (fieldSelector, value, fieldName) => await this.handleFormChange(fieldSelector, value, fieldName));

        // start up with the sign-up button being disabled
        this._view.isSignUpButtonEnable = false;

        this._view.scrollToTop();

        // set focus on email field on start up
        setTimeout(() => {
            this._view.focusOnElement('email');
        }, 500);

    }

    isEmailValid(email) {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return email && emailPattern.test(email);
    }

    async validate() {

        this.errors = [];

        // if (!this.isValidUSPhoneNumber(this._view.phone)) {
        //     this.errors.push(
        //         new ValidationError(
        //             '',
        //             'Phone is invalid.',
        //             'signUpPresenter.InvalidPhoneNumber',
        //             '',
        //             'phone'
        //         )
        //     );
        // }


        if (!this._view.email) {
            this.errors.push(
                new ValidationError(
                    UuidHelper.newId(),
                    'Email address cannot be empty.',
                    'captureEmailPresenter.EmailCannotBeEmpty',
                    '0935dc2e-b521-4ce1-8455-3ee85a167e82',
                    'email'
                )
            );
        } else {
            if (!this.isEmailValid(this._view.email)) {
                this.errors.push(
                    new ValidationError(
                        UuidHelper.newId(),
                        'Invalid email address.',
                        'captureEmailPresenter.InvalidEmailAddress',
                        '0935dc2e-b521-4ce1-8455-3ee85a167e82',
                        'email'
                    )
                );
            }
        }

        if (!this._view.firstName) {
            this.errors.push(
                new ValidationError(
                    UuidHelper.newId(),
                    'First name cannot be empty.',
                    'captureEmailPresenter.FirstNameCannotBeEmpty',
                    '92cbbfb8-201d-4f6b-9eac-c3214d5b731e',
                    'firstName'
                )
            );
        }


        if (!this._view.lastName) {
            this.errors.push(
                new ValidationError(
                    UuidHelper.newId(),
                    'Last name cannot be empty.',
                    'captureEmailPresenter.LastNameCannotBeEmpty',
                    '5186047d-ba8b-4c8c-b88a-5be5853d81f1',
                    'lastName'
                )
            );
        }

        this._view.isSignUpButtonEnable = (this.getCombinedErrors().length === 0);

    }

    // isValidUSPhoneNumber(rawInput: string): boolean {
    //     // Remove all non-numeric characters
    //     let digits = rawInput.replace(/\D/g, '');
    //
    //     // If starts with '1' and length is 11, strip the leading '1'
    //     if (digits.length === 11 && digits.startsWith('1')) {
    //         digits = digits.substring(1);
    //     }
    //
    //     // Check if exactly 10 digits remain
    //     return digits.length === 10;
    // }

    getCombinedErrors() {
        return this.errors.concat(this.serverErrors);
    }


    async signUp() {

        try {

            this._loading.setBody("Loading...");
            this._loading.show(true);

            const signUpResult = await this._tenantApi.post({
                    "signUp": {
                        email: this._view.email,
                        firstName: this._view.firstName,
                        lastName: this._view.lastName,
                        password: UuidHelper.newId()
                    }
                },
                null,
                false,
                true
            );

            if (signUpResult?.data?.bearerToken) {
                await this._userStore.fetch(this._tenantApi);

                await this._tenantProfileStore.fetch(
                    this._tenantProfileApi,
                    this._userStore.getTenantProfileId(),
                    this._userStore.getParentTenant()
                )

                if (this._bedrooms != null && this._bathrooms != null) {
                    
                    const bookingStore = this.dependencyContainer.resolve<BookingStore>('BookingStore');

                    let booking = bookingStore.getBooking();

                    if (!booking) {
                        await bookingStore.pull(async (currentBooking) => {
                            booking = currentBooking;
                        });
                    }
                    
                    const bookingApi = this.dependencyContainer.resolve<BookingApi>('BookingApi');
                    await bookingApi.post(
                        {
                            setCleaningEstimate: {
                                id: booking.id,
                                bedrooms: this._bedrooms,
                                bathrooms: this._bathrooms
                            }
                        },
                        this._userStore.getParentTenant(),
                        true
                    );
                }

                this._router.navigate('/#/home');
            }

        } catch (e) {

            if (e.status === 400) {
                if (e.response?.data?.errors && e.response?.data?.errors.length > 0) {
                    this._view.setErrorList(e.response?.data?.errors);
                }
            }

        } finally {
            this._loading.show(false);
        }


    }

    inject() {
    }

}
